import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

type GridContentProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    props?: any
    children?: JSX.Element
    xxlBreakpointEnabled: boolean
}

export const GridContent = memo(({templating, xxlBreakpointEnabled, props, children}: GridContentProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props} xxlBreakpointEnabled={xxlBreakpointEnabled}>
                {children}
            </ComponentName>
        </Suspense>
    )
})
GridContent.displayName = "GridContent"

export default connect(GridContent)
